import { Card, Header, Label } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import getProductionManagers from "astrid-firestore/src/api/todos/helpers/team/managers/getProductionManagers";

import Flex from "../../../../components/Flex/Flex";

import ProductionStatusLabel from "../../../productions/components/ProductionStatus/ProductionStatusLabel";

import CoverImage from "../CoverImage/CoverImage";
import ImageAvatar from "../ImageAvatar/ImageAvatar";

export default function ProductionCard({ production, articles, onClick, ...style }) {
	const { t } = useTranslation();

	const articleCount = articles?.filter((article) => production.articleIds?.includes(article.id)).length;

	const deliveryDate = production.deliveryDate?.toDate().toLocaleDateString();
	const dueDate = production.productionDate?.toDate().toLocaleDateString();

	const isbns =
		production.isbns?.length > 1
			? `${production.isbns?.[0]} + ${production.isbns?.length - 1}`
			: production.isbns?.[0];

	const productionManagers = getProductionManagers({ production });

	return (
		<Card fluid style={{ cursor: "pointer" }} onClick={onClick} {...style}>
			<Card.Content>
				<div
					style={{
						display: "flex",
						gap: "1em",
						alignItems: "flex-start",
						color: "grey",
					}}
				>
					<CoverImage modal thumb rounded data={production} size={80} style={{ margin: "0 auto" }} />

					<div style={{ flex: 1 }}>
						<Header as="h3">
							{production.title}

							<Header.Subheader>
								{`${production.publisherName} + ${production.producerName}`}
							</Header.Subheader>

							<Header.Subheader style={{ marginTop: 5 }}>
								{articleCount > 0 && `${articleCount} ${t("articles", "articles")} (${isbns})`}
							</Header.Subheader>
						</Header>
					</div>

					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							gap: "0.5em",
						}}
					>
						<ProductionStatusLabel status={production.status} />

						<Flex justifyContent="flex-end" gap={10} style={{ flexShrink: 0 }}>
							{productionManagers.map((pM) => {
								return (
									<Flex key={pM.id} gap={5} justifyContent="flex-end" style={{ margin: "2px 0" }}>
										<ImageAvatar src={pM.img} size={40} />

										<div style={{ whiteSpace: "nowrap" }}>{pM.firstName + " " + pM.lastName}</div>
									</Flex>
								);
							})}
						</Flex>
					</div>
				</div>
			</Card.Content>

			{(deliveryDate || dueDate) && (
				<Card.Content style={{ color: "black" }}>
					<Flex justifyContent="flex-start" gap={5}>
						{deliveryDate && (
							<Label basic circular>
								{t("deliveryDate", "Delivery date")}: {deliveryDate}
							</Label>
						)}

						{dueDate && (
							<Label basic circular>
								{t("productionDate", "Due date")}: {dueDate}
							</Label>
						)}
					</Flex>
				</Card.Content>
			)}
		</Card>
	);
}
